import React, { useState, useEffect } from "react";
import classnames from "classnames/bind";
import { Redirect } from "react-router-dom";

import css from "./index.scss";

const cx = classnames.bind(css);
const moduleName = "Admin";

const Admin = () => {
  const [redirect, setRedirect] = useState(false);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    const password = window.prompt("비밀번호를 입력해주세요!");
    setIsAuth(password === "as8205");
  }, []);

  const signin = () => {
    const stored = window.localStorage.getItem("passwordForSignIn");
    if (!stored) {
      const password = window.prompt("비밀번호를 입력해주세요!");
      if (password === "as8205") {
        window.localStorage.setItem("passwordForSignIn", password);
        window.alert("로그인 되었습니다");
      } else {
        window.alert("비밀번호가 틀립니다");
      }
    } else {
      window.alert("이미로그인되어 있습니다");
    }
    setRedirect(true);
  };

  const logout = () => {
    window.localStorage.removeItem("passwordForSignIn");
    setRedirect(true);
  };

  if (redirect || !isAuth) {
    return <Redirect to="/" />;
  }

  return (
    <div className={cx(`${moduleName}`)}>
      <h4>로그인페이지</h4>
      <button className={cx(`${moduleName}-button`)} onClick={signin}>
        주인장 로그인
      </button>
      <button className={cx(`${moduleName}-button`)} onClick={logout}>
        로그아웃하기
      </button>
    </div>
  );
};

export default Admin;



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Admin/index.js